import { GetFragmentDto } from '@mi-front/core';
import { isVideoStation } from '../../../../../../../core/stations/helpers';
import { useStation } from '../../../../../../../core/stations/hooks/useStation';
import { Stack } from '@mui/material';
import React from 'react';
import { DownloadMediaBtn } from './DownloadMediaBtn';

interface Props {
  fragment: GetFragmentDto;
}

export function DownloadMedia({ fragment }: Props) {
  return (
    <Stack direction="row" spacing={2}>
      {isVideoStation(useStation(fragment.stationId)) && (
        <DownloadMediaBtn id={fragment.id} mediaType={'VIDEO'} />
      )}
      <DownloadMediaBtn id={fragment.id} mediaType={'AUDIO'} />
    </Stack>
  );
}
